<template>
    <b-modal ref='passwordVerificationModal' centered :no-close-on-esc='true' :no-close-on-backdrop='true' :hide-header-close='true' cancel-title=''>
        <local-error v-bind:inline='["current_password"]'></local-error>
        <p>{{ $t(message) }}:</p>
        
        <div class="form-group">
            <label for="current_password">{{ $t('translations.password')}}</label>
            <div class="input-group">
                <input ref='passwordField' class="form-control" id="current_password" :type="passwordFieldType" v-model='current_password' required autocomplete="current-password">
                <div class="input-group-append">
                    <button ref='showhide' @click.prevent="switchVisibility" class="input-group-text">{{passwordFieldType === 'password' ? "show" : "hide"}}</button>
                </div>
                <inline-error v-bind:errors='errors' type='current_password'></inline-error>
            </div>
        </div>
        
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-left" variant="info" v-on:click.prevent='$refs.passwordVerificationModal.hide()'>
                {{ $t("translations.cancel")}}
            </b-btn>
            <b-btn size="sm" class="float-right" variant="success" v-on:click.prevent='verify()'>
                {{ $t("translations.verify")}}
            </b-btn>
        </div>
    </b-modal>        
</template>

<script>

export default {

    props: {
        'route': {default: '/api/vp1/patients'},
        'item': {
            default: () => {return {}}
        },
        'message': {default: "translations.password_verification_text"},
        'success': null,
    },
    data: function() {
        return {
            errors: [],
            current_password: null,
            passwordFieldType: "password",
        };
    },
    mounted() {
        
    },
    methods: {
        switchVisibility() {
	            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
	            this.show = this.show === 'show' ? 'hide' : 'show';
	           // this.$refs.passwordField.focus();
	        },
        show() {
            this.errors = [];
            this.$refs.passwordVerificationModal.show()
        },
        verify() {
            this.setLoading(true);
            return axios.post(`${this.$root.apiBase}/auth/verifyPassword`, {current_password: this.current_password}).then((res) => {
                this.setLoading(false);
                this.$refs.passwordVerificationModal.hide();
                this.$emit("validated", this.current_password);
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "verify");
            });
        },
    }
}

</script>
